//
export default {

  /**
   * 
   */
  toList() {
    return [
      {
        text: '#',
        value: 'id',
      },
      {
        text: 'codigo interno',
        value: 'internal_code',
      },
      {
        text: 'alias',
        value: 'alias_name',
      },
      {
        text: 'descripción',
        value: 'description',
      },
    ]
  }
}